import { DateTimeFormatter } from 'cng-web-lib'
import moment from 'moment'

function formatDate(dateString) {
  if (!dateString) return ''
  return DateTimeFormatter.formatDate(dateString)
}

function formatDateTime(dateString) {
  if (!dateString) return ''
  return moment(dateString).format('D MMM YYYY, HH:mm')
}

export { formatDate, formatDateTime }
